import { styled } from "styled-components";

export const PersonalPercentBar = styled.div`
  margin-top: 20px;
  height: 30%;
  width: 80%;

  border: 3px solid black;
  border-radius: 30px;
  overflow: hidden;

  display: flex;
`;
